import React from "react";
import styles from './ComponentSASSBreadcrumb.scss';

import circleImg from './img/Steps-OK.svg';
import {__t} from "../../common/lang/text-resource";

const Step = ({active, passed, title, titleMob, label}) => {
	const classNames = [
		styles.step
	];

	if (active) {
		classNames.push(styles.active);
	}

	return (
	  <div className={classNames.join(" ")}>
		  {!passed && <div className={styles.circle}>{label}</div>}
		  {passed && <img src={circleImg} className={styles.passedImg}/>}
		  <div className={styles.text}>
			  <span className={styles.mob_no}>{title}</span>
			  <span className={styles.mob_yes}>{titleMob}</span>
		  </div>
	  </div>
	)
}

const ComponentSASSBreadcrumb = ({activeStep}) => {

	return (
	  <>
		  <div className={styles.sasBreadcrumb}>
			  <Step active={activeStep === 1} passed={activeStep > 1} label={"1"} title={__t("Регистрация на потребител")}
					titleMob={__t("Регистрация")}/>
			  <div className={`${styles.divider} ${activeStep > 1 && styles.passed}`}></div>
			  <Step active={activeStep === 2} passed={activeStep > 2} label={"2"} title={__t("Избор на име")}
					titleMob={__t("Избор на име")}/>
			  <div className={`${styles.divider} ${activeStep > 2 && styles.passed}`}></div>
			  <Step active={activeStep === 3} passed={activeStep > 3} label={"3"} title={__t("Създай тестов магазин")}
					titleMob={__t("Създай тестов магазин")}/>
		  </div>
	  </>
	)
}

export default ComponentSASSBreadcrumb;